/**
 * UK Warehouse Stock Availability
 * ──────────────────────────────
 * Runs on product pages for UK customers only.
 * Fetches real-time stock from the UK warehouse and disables
 * the Add to Cart button if the selected variant is out of stock.
 *
 * This script is loaded by the stock-check.liquid snippet,
 * which only renders for UK visitors (localization.country.iso_code == 'GB').
 */

(function () {
  'use strict';

  // ── Configuration ──────────────────────────────────────────────────────────
  // APP_URL is set by the Liquid snippet to avoid hardcoding it here
  const APP_URL = window.UK_FULFILLMENT_APP_URL || 'https://welton-london.lincraft-app.com';
  const COUNTRY = window.COUNTRY_ISO || 'FR';

  // CSS class added to the button when it's forced into "sold out" state
  const SOLD_OUT_CLASS = 'uk-sold-out';

  // ── DOM References ─────────────────────────────────────────────────────────
  const wrapper = document.getElementById('stock-wrapper');
  if (!wrapper) return; // Not a UK customer — snippet didn't render

  // Find the Add to Cart button
  // These selectors cover Dawn theme and most common third-party themes.
  // Add more selectors below if your theme uses a different one.
  const ADD_TO_CART_SELECTORS = [
    '[name="add"]',                          // Standard Shopify
    '.product-form__submit',                 // Dawn theme
    '.btn--add-to-cart',                     // Common third-party
    '[data-add-to-cart]',                    // Custom themes
    '#AddToCartForm button[type="submit"]',  // Older themes
    '.product-form__cart-submit',            // Your current theme button
    '.btn.product-form__cart-submit',        // More specific fallback
  ];

  function findAddToCartButton() {
    for (const selector of ADD_TO_CART_SELECTORS) {
      const btn = document.querySelector(selector);
      if (btn) return btn;
    }
    return null;
  }

  // ── Stock Check ───────────────────────────────────────────────────────────

  /**
   * Set the button to "Sold Out" (disabled, different text).
   * Stores the original text so we can restore it if the variant changes.
   */
  function markSoldOut(button) {
    if (button.dataset.originalText === undefined) {
      button.dataset.originalText = button.textContent.trim();
    }
    console.log('button', button)
    button.disabled = true;
    button.textContent = 'Sold Out';
    button.classList.add(SOLD_OUT_CLASS);

    // Hide dynamic checkout / Shop Pay button
    const paymentButton = document.querySelector(
      '[data-shopify="payment-button"]'
    );

    if (paymentButton) {
      paymentButton.style.display = 'none';
    }
  }

  /**
   * Restore the button to its original enabled state.
   */
  function markAvailable(button) {
    button.disabled = false;
    if (button.dataset.originalText) {
      button.textContent = button.dataset.originalText;
    }
    button.classList.remove(SOLD_OUT_CLASS);
  }

  /**
   * Fetch UK stock for a given SKU from our Node.js app.
   * Returns { available: boolean, quantity: number } or null on error.
   */
  async function fetchUkStock(sku) {
    console.log('sku', sku)
    if (!sku) return null;

    try {
      const response = await fetch(`${APP_URL}/api/stock/${encodeURIComponent(sku)}/${COUNTRY}`, {
        method: 'GET'
      });

      if (!response.ok) return null;
      return await response.json();
    } catch {
      // Network error or timeout — fail silently, don't block the button
      return null;
    }
  }

  /**
   * Check stock for the given SKU and update the Add to Cart button.
   */
  async function checkAndUpdateStock(sku) {
    const button = findAddToCartButton();
    if (!button) return;

    const stockData = await fetchUkStock(sku);
    console.log('stockData', stockData)

    if (stockData && stockData.available <= 0) {
      markSoldOut(button);
    } else {
      // Available, or API failed (fail open — don't block checkout)
      markAvailable(button);
    }
  }

  // ── Initialization ─────────────────────────────────────────────────────────

  // Run on page load with the current/default variant
  const initialSku = wrapper.dataset.sku;
  if (initialSku) {
    checkAndUpdateStock(initialSku);
  }

  // ── Variant Change Listener ────────────────────────────────────────────────
  //
  // When the customer selects a different variant (e.g. size/colour),
  // we re-check stock for the newly selected variant.
  //
  // Shopify themes dispatch a 'variant:change' custom event on the document.
  // This works with Dawn theme and most modern themes.

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    if (variant && variant.sku) {
      wrapper.dataset.sku = variant.sku;
      wrapper.dataset.variantId = variant.id;
      checkAndUpdateStock(variant.sku);
    }
  });

  // Fallback: Listen for URL changes (some themes update the URL on variant change)
  // and re-read the variant from the page
  let lastUrl = location.href;
  const urlObserver = new MutationObserver(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      // Try to get the variant from the URL params
      const params = new URLSearchParams(location.search);
      const variantId = params.get('variant');

      if (variantId) {
        // Find the SKU from the page's variant data if available
        const variantData = window.ShopifyAnalytics?.meta?.selectedVariantId;
        if (variantData) {
          // Re-read the wrapper's SKU which may have been updated by the theme
          const currentSku = wrapper.dataset.sku;
          if (currentSku) checkAndUpdateStock(currentSku);
        }
      }
    }
  });

  urlObserver.observe(document.body, { childList: true, subtree: true });
})();
